module.exports = __webpack_public_path__ + "static/media/kantoushan_web.580e5c96.png";